import logo from './logo.svg';
import { isAndroid, isIOS } from 'react-device-detect';
import './App.css';

function App() {

  if (isAndroid) {
    window.location.replace('https://play.google.com/store/apps/details?id=com.jyothi.calendar');
    return;
  }
  else if (isIOS) {
    window.location.replace('https://apps.apple.com/us/app/jyothi-panchanga/id1663573739');
    return;
  }

  return (
    <div className="App">
      Unsupported Device. iOS and Android only
    </div>
  );
}

export default App;
